import { render } from "./registration-user-form.vue?vue&type=template&id=4e0d9848&scoped=true"
import script from "./registration-user-form.vue?vue&type=script&lang=js"
export * from "./registration-user-form.vue?vue&type=script&lang=js"

import "./registration-user-form.vue?vue&type=style&index=0&id=4e0d9848&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0d9848"]])

export default __exports__